import { render, staticRenderFns } from "./VideocastButton.vue?vue&type=template&id=39d291a1"
import script from "./VideocastButton.vue?vue&type=script&lang=js"
export * from "./VideocastButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports